import $ from 'jquery';
import { initTooltips } from '@/js/modules/tooltips';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  const syncWithQuickBooks = (id, kind) => {
    const $td = $(`tr[data-id=${id}]`).find('.quickbooks-sync-status');
    $td.html('<span class="quickbooks-sync-status__syncing">Syncing...</span>');

    $.post(`/quickbooks_sync/${kind}/${id}`, (data) => {
      if (data.warning_html) {
        $td.html(data.warning_html);
        initTooltips($td.find('.tooltip'));
        return;
      }

      setTimeout(function () {
        getQuickBooksSyncStatus(data.billable_id, kind, $td);
      }, 5000);
    });
  };

  const getQuickBooksSyncStatus = (id, kind, $td) => {
    $.get(`/quickbooks_sync/${kind}/${id}/xhr_status`, (data) => {
      if (data.quickbooks_sync_status === 'sync_started') {
        $td.html('<span class="quickbooks-sync-status__syncing">Syncing...</span>');
        setTimeout(function () {
          getQuickBooksSyncStatus(id, kind, $td);
        }, 5000);
      } else if (data.quickbooks_sync_status === 'sync_completed') {
        if (data.warning_html) {
          $td.html(data.warning_html);
          initTooltips($td.find('.tooltip'));
        } else {
          $td.html('In-Sync');
        }
        const $viewOnQuickbooks = $(`tr[data-id="${id}"]`).find(
          '.dropdown-menu__link--view-on-quickbooks'
        );
        $viewOnQuickbooks.removeClass('hide');

        if (data.view_on_quickbook_path.includes('javascript:void(0);')) {
          $viewOnQuickbooks.addClass('dropdown-menu__link--disabled');
        }

        $viewOnQuickbooks.attr('href', data.view_on_quickbook_path);
      } else if (
        data.quickbooks_sync_status === 'sync_error' ||
        data.quickbooks_sync_status === 'sync_connection_error'
      ) {
        $td.html(`<button type="button" class="t-button t-button--red tooltip tooltip--interactive quickbooks-sync-status__retry quickbooks-sync-status__button">
          <i class="fa-regular fa-circle-exclamation" aria-hidden="true"></i>Retry
          <div class="tooltip__content">
            <small>Error</small><br>
            ${data.quickbooks_sync_error}
          </div>
        </button>`);
        initTooltips($td.find('.tooltip'));
      } else if (data.warning_html) {
        $td.html(data.warning_html);
        initTooltips($td.find('.tooltip'));
      }
    });
  };

  $(document).ready(() => {
    if (
      $('body').is('#invoices') ||
      $('body').is('#retainers') ||
      $('body').is('#purchase_orders') ||
      $('body').is('#financials')
    ) {
      $('.quickbooks-sync-status__syncing').each((i, el) => {
        const id = $(el).parents('tr').data().id;
        const kind = $(el).parents('tr').data().kind;
        const $td = $(el).parents('tr').find('.quickbooks-sync-status');

        getQuickBooksSyncStatus(id, kind, $td);
      });
    }
  });

  $('.dropdown-menu__toggle--sync-with-quickbooks input[type="checkbox"]').on('change', (e) => {
    e.preventDefault();
    const $tr = $(e.target).parents('tr');
    const id = $tr.data().id;
    const kind = $tr.data().kind;

    const checked = $(e.target).is(':checked');

    $.post(`/quickbooks_sync/${kind}/${id}/xhr_toggle`, { quickbooks_sync: checked }, (data) => {
      if (checked) {
        syncWithQuickBooks(data.billable_id, kind);
        $tr.find('.dropdown-button--active').removeClass('dropdown-button--active');
      } else {
        const $td = $tr.find('.quickbooks-sync-status');
        $td.html('-');
        const $viewOnQuickbooks = $tr.find('.dropdown-menu__link--view-on-quickbooks');
        $viewOnQuickbooks.addClass('hide');
      }
    });
  });

  $(document).on('click', '.quickbooks-sync-status__retry', (e) => {
    e.preventDefault();
    const $el = $(e.target);
    const id = $el.parents('tr').data().id;
    const kind = $el.parents('tr').data().kind;

    syncWithQuickBooks(id, kind);
  });
});
